
<main class=" terms-conditions">
	<h3 class="mb-3">CloRent Factory – Terms &amp; Conditions</h3>

	<!-- <p><strong>Effective Date:</strong> [Add Date]</p> -->
	<p>
		By downloading, registering, or using the <em>CloRent Factory</em> mobile application or website (“Platform”), you agree to
		comply with these Terms &amp; Conditions. If you do not agree, please stop using the Platform immediately.
	</p>

	<hr>

	<h4>1. About CloRent Factory</h4>
	<p>
		CloRent Factory is a <em>digital real estate platform</em> that allows users to view, post, and manage property listings such
		as rental, resale, commercial, and new projects. We only provide <em>technology services</em> and do not participate in
		property transactions.
	</p>

	<hr>

	<h4>2. User Eligibility</h4>
	<ul>
		<li>Users must be <em>18 years or older</em>.</li>
		<li>You must provide <em>true and correct information</em>.</li>
		<li>You are responsible for all activities under your account.</li>
	</ul>

	<hr>

	<h4>3. Role of CloRent Factory</h4>
	<ul>
		<li>We are <em>not a broker, agent, builder, or property owner</em>.</li>
		<li>We do <em>not guarantee</em> property accuracy, pricing, or availability.</li>
		<li>Any deal or agreement is strictly between <em>buyer, seller, owner, or broker</em>.</li>
	</ul>

	<hr>

	<h4>4. Property Listings</h4>
	<ul>
		<li>Listings are uploaded by users at their own responsibility.</li>
		<li>Fake, duplicate, misleading, or illegal listings are strictly prohibited.</li>
		<li>CloRent Factory may remove any listing without prior notice.</li>
	</ul>

	<hr>

	<h4>5. Paid Services (If Any)</h4>
	<ul>
		<li>Some features may be paid or subscription-based.</li>
		<li>All payments are <em>final and non-refundable</em>.</li>
		<li>Prices and plans may change without prior notice.</li>
	</ul>

	<hr>

	<h4>6. User Conduct</h4>
	<p>You agree not to:</p>
	<ul>
		<li>Misuse user data or contact details.</li>
		<li>Post offensive, illegal, or fraudulent content.</li>
		<li>Attempt hacking, data theft, or system misuse.</li>
	</ul>
	<p>Violation may lead to <em>account suspension or permanent ban</em>.</p>

	<hr>

	<h4>7. Third-Party Services</h4>
	<p>
		We may use third-party services such as payment gateways, SMS, WhatsApp, maps, or analytics. CloRent Factory is
		<em>not responsible</em> for third-party service issues.
	</p>

	<hr>

	<h4>8. Limitation of Liability</h4>
	<p>CloRent Factory shall not be responsible for:</p>
	<ul>
		<li>Financial loss or failed transactions.</li>
		<li>Property disputes or fraud.</li>
		<li>Business loss or data loss.</li>
	</ul>
	<p>Use the Platform at your <em>own risk</em>.</p>

	<hr>

	<h4>9. Account Termination</h4>
	<p>We reserve the right to:</p>
	<ul>
		<li>Suspend or terminate accounts at any time.</li>
		<li>Remove content violating these Terms.</li>
		<li>Restrict access without notice if misuse is found.</li>
	</ul>

	<hr>

	<h4>10. Changes to Terms</h4>
	<p>
		CloRent Factory may update these Terms anytime. Continued use of the Platform means you accept the updated Terms.
	</p>

	<hr>

	<h4>11. Governing Law</h4>
	<p>
		These Terms shall be governed by the <em>laws of India</em>, and disputes will be subject to courts of <em>[Your City/State]</em>.
	</p>

	<hr>

	<h4>12. Contact Us</h4>
	<p>
		<strong>Email:</strong> Clorentfactory&#64;gmail.com<br>
		<strong>Phone:</strong> 7775028877
	</p>
</main>
